import { Box, Typography } from '@mui/material'
import PageTitle from '../Common/PageTitle'
import { useLocation } from 'react-router-dom';
import { Connect, mapStateToProps } from '../../Redux';
import { FC, useState } from 'react';
import { PropertyProps } from '../../types/properties';
import moment from 'moment';
import { getImageUrl, numberWithCommas } from '../../helpers';

interface Props {
    selectedProperty?: PropertyProps
}
const Invoice: FC<Props> = ({
    selectedProperty
}) => {
    const location = useLocation()
    const [imgFailed, setImgFailed] = useState(false)

    const { record } = location.state
    const { invoiceNo, date } = record
    const propertyName = selectedProperty?.name || ''
    const logoUrl = getImageUrl(selectedProperty?.logos, 'small')
    const showFallback = !logoUrl || imgFailed
    const initials = propertyName.split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2)
    const stats = [
        { label: 'Arrears B/F', field: 'arrearsBF', },
        { label: 'Current Month Arrears', field: 'arrears' },
        { label: 'Arrears C/F', field: 'arrearsCF' },
        { label: 'Vacant Units', field: 'vacant' },
        { label: 'Expected Revenue', value: record.revenue + record.arrearsBF + record.arrears },
        { label: 'Revenue', field: 'revenue' },
        { label: 'Expenditure', field: 'expenditures' },
        { label: 'Net', field: 'net' }
    ]
    return (
        <Box>
            <PageTitle backBtn title={'Summary No'} />
            <Box sx={{
                mt: 5,
                ml: 8,
                height: '70vh'
            }}>
                <Box sx={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center'
                }} mb={5}>
                    {showFallback ?
                        <Box sx={{
                            height: 50, width: 50, borderRadius: '50%', bgcolor: '#8c7c0c',
                            display: 'flex', alignItems: 'center', justifyContent: 'center'
                        }}>
                            <Typography sx={{ fontSize: 16, fontWeight: 800, color: '#fff' }}>{initials}</Typography>
                        </Box> :
                        <img
                            src={logoUrl}
                            onError={() => setImgFailed(true)}
                            style={{ height: 50, width: 50, borderRadius: '50%', objectFit: 'cover' }}
                        />
                    }
                    <Box ml={1}>
                        <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>{selectedProperty?.name}</Typography>
                        <Typography sx={{ fontSize: 13 }}>{selectedProperty?.location + ', ' + selectedProperty?.placeName}</Typography>
                    </Box>
                </Box>
                <Box
                    sx={{ maxWidth: '90%' }}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                         mb:10
                    }}>
                        <Typography sx={{ fontSize: 13 }}>
                            Summary No. {invoiceNo}
                        </Typography>
                        <Typography sx={{ fontSize: 13 }}>
                            Date: {moment(date).format('DD MMM YYY')}
                        </Typography>
                    </Box>
                    {
                        stats.map(({label, field, value}, index) => {
                            value = value || (field === 'net' ? (record.revenue - record.expenditures) : (record as any)[field as string])
                            return(
                            <Box key={label}
                            sx={{
                                flexDirection:'row',
                                backgroundColor: !(index % 2) ?  '#ECEBEB': 'transparent',
                                display:'flex',
                                 justifyContent:'space-between',
                                p:2
                            }}
                            >
                                <Typography sx={{fontSize:14, fontWeight:field === 'net'?'bold':'normal'}}>{label}</Typography>
                                <Typography sx={{fontSize:14,  fontWeight:field === 'net'?'bold':'normal'}}>Ksh {numberWithCommas(value)}</Typography>
                            </Box>
                        )})
                    }
                </Box>

            </Box>
        </Box>
    )
}

export default Connect(mapStateToProps)(Invoice)